export default __webpack_public_path__ + "static/media/img_note3.a3e48326.png";